// extracted by mini-css-extract-plugin
export var authors = "PostList-module--authors--04a92";
export var container = "PostList-module--container--895a3";
export var controls = "PostList-module--controls--a0c03";
export var current = "PostList-module--current--f11db";
export var group = "PostList-module--group--86879";
export var groupLabel = "PostList-module--group-label--e2f27";
export var hasPrefix = "PostList-module--has-prefix--3639a";
export var intro = "PostList-module--intro--b7805";
export var isPending = "PostList-module--is-pending--fa743";
export var item = "PostList-module--item--a8ce0";
export var list = "PostList-module--list--7dff9";
export var publishedDate = "PostList-module--published-date--94692";
export var showBubbles = "PostList-module--show-bubbles--17997";
export var showList = "PostList-module--show-list--7feea";
export var title = "PostList-module--title--63c13";
export var titlePrefix = "PostList-module--title-prefix--7f8a5";